import Box from '@mui/material/Box';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { AnalyticsTile } from './AnalyticsTile';
import { ViewsLead, ViewsTopRow, type ViewsTileProps } from './ViewsTopRow';
import { useHasPermission } from '../../../auth';
import { tokens } from '../../../design';
import { carListingDetailPath } from '../../../routes';
import { formatViews } from '../_lib/formatViews';

export const TopListingsTile = ({
  data,
  isLoading,
  isError,
  gridColumn,
}: ViewsTileProps): ReactElement => {
  const { t } = useTranslation();
  const canOpen = useHasPermission('verify_inspectors');
  return (
    <AnalyticsTile
      label={t('dashboard.views.topListings')}
      gridColumn={gridColumn}
      isLoading={isLoading}
      isError={isError}
      hasData={Boolean(data)}
    >
      {data && data.topListings.length === 0 ? (
        <Box sx={{ fontSize: 13, color: tokens.text.tertiary, py: 1 }}>
          {t('dashboard.views.empty')}
        </Box>
      ) : null}
      {data?.topListings.map((row, i) => (
        <ViewsTopRow
          key={row.listingId}
          rank={i + 1}
          lead={<ViewsLead url={row.coverUrl} fallback="—" />}
          name={row.title}
          sub={row.sellerName}
          chip={row.status === 'active' ? null : t(`marketplace.listings.status.${row.status}`)}
          count={formatViews(row.views)}
          to={canOpen ? carListingDetailPath(row.listingId) : undefined}
        />
      ))}
    </AnalyticsTile>
  );
};
